import React from 'react';

interface LabelProps {
    text: string;
    textColor?: string;
    backgroundColor?: string;
    className?: string;
    marginBottom?: number;
}

const LabelTag = ({
                      text,
                      textColor = 'white',
                      backgroundColor = '#000000',
                      marginBottom = 0,
                  }: LabelProps) => {
    return (
        <span
            style={{
                color: textColor,
                backgroundColor: backgroundColor,
                fontSize: '9pt',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '3px',
                paddingBottom: '3px',
                borderRadius: '3px',
                display: 'inline-block',
                whiteSpace: 'nowrap',
                marginRight: '3px',
                marginBottom: `${marginBottom}px`,
                fontFamily: 'Source Sans Pro',
            }}>
      {text}
    </span>
    );
};

export default LabelTag;
